export default {
  it: 'Crea il tuo avatar',
  de: 'Erstelle deinen Avatar',
  fr: 'Crée ton avatar',
  en: 'Create Your Avatar'
};
